module.exports = __webpack_public_path__ + "img/s_5.467fe622.png";